import "@fontsource-variable/fraunces/opsz.css";
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/600.css";
import "@fontsource/ibm-plex-sans/400-italic.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import "./styles.css";
import { StrictMode, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { Spinner } from "./components/ui";
import { navigate, SessionProvider, Toasts, useAppliedTheme, usePath, useSession } from "./lib/app";
import { AdminArea } from "./admin/AdminArea";
import { AccountPage } from "./pages/Account";
import { InvitePage, LoginPage } from "./pages/Auth";
import { Dashboard } from "./pages/Dashboard";
import { ProjectPage } from "./project/ProjectPage";
import { resumeRave } from "./project/rave";

function Routes() {
  const path = usePath();
  const { user, loading, theme } = useSession();
  useAppliedTheme(theme);

  const invite = /^\/invite\/([^/]+)$/.exec(path);
  const isPublic = path === "/login" || !!invite;

  useEffect(() => {
    if (loading) return;
    if (!user && !isPublic) navigate(`/login${path !== "/" ? `?next=${encodeURIComponent(path)}` : ""}`, true);
    if (user && path === "/login") navigate("/", true);
  }, [user, loading, path, isPublic]);

  // A rave keeps going through a reload (see project/rave.ts).
  const me = user?.id;
  useEffect(() => {
    if (me) resumeRave(me);
  }, [me]);

  if (loading) {
    return (
      <div style={{ height: "100%", display: "grid", placeItems: "center" }}>
        <Spinner size={22} />
      </div>
    );
  }
  if (invite) return <InvitePage token={decodeURIComponent(invite[1])} />;
  if (!user) return <LoginPage />;

  const project = /^\/project\/([A-Za-z0-9]+)/.exec(path);
  if (project) return <ProjectPage key={project[1]} projectId={project[1]} />;
  if (path === "/admin" || path.startsWith("/admin/")) return <AdminArea path={path} />;
  if (path === "/account") return <AccountPage />;
  return <Dashboard />;
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <SessionProvider>
      <Routes />
      <Toasts />
    </SessionProvider>
  </StrictMode>,
);
